import { Button, Tooltip } from 'antd';
import { ButtonProps } from 'antd/es/button';
import cx from 'classnames';
import { FC, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import ReactMde from 'react-mde';

import './styles.scss';

type Props = {
  value?: string;
  onChange?: (text: string) => void;
  isPreviewHTML?: boolean;

  // button
  showButton?: boolean;
  tooltipTitle?: string;
} & ButtonProps;

const MarkdownField: FC<Props> = (props: Props) => {
  const {
    value,
    onChange,
    isPreviewHTML = false,

    // button
    showButton = false,
    tooltipTitle,
    onClick,
    disabled = false,
    loading = false,
    icon,
  } = props;
  const [selectedTab, setSelectedTab] = useState<'write' | 'preview'>('write');

  const generateMarkdownPreview = (markdown) => {
    if (isPreviewHTML) {
      return Promise.resolve(<div dangerouslySetInnerHTML={{ __html: markdown }}></div>);
    }
    return Promise.resolve(<ReactMarkdown>{markdown}</ReactMarkdown>);
  };

  return (
    <div className={cx({ 'cbra-textarea-wrapper': showButton })}>
      <ReactMde
        value={value}
        onChange={onChange}
        selectedTab={selectedTab}
        onTabChange={setSelectedTab}
        generateMarkdownPreview={(markdown) => generateMarkdownPreview(markdown)}
        childProps={{
          writeButton: {
            tabIndex: -1,
          },
        }}
      />
      {showButton && loading && (
        <Button
          icon={icon}
          disabled={disabled}
          loading={loading}
          onClick={(e) => {
            if (onClick) onClick(e);
          }}
        />
      )}

      {showButton && !loading && (
        <Tooltip title={tooltipTitle}>
          <Button
            icon={icon}
            disabled={disabled}
            loading={loading}
            onClick={(e) => {
              if (onClick) onClick(e);
            }}
          />
        </Tooltip>
      )}
    </div>
  );
};

export default MarkdownField;
